// Below code is for bug fix to prevent Select Dropdown DatePicker TimePicker etc. scrolling with the page
// https://ant.design/docs/react/faq#how-do-i-prevent-select-dropdown-datepicker-timepicker-popover-popconfirm-scrolling-with-the-page
export const getPopupContainer = (trigger: HTMLElement): HTMLElement => trigger.parentElement as HTMLElement;
